import { useState, useEffect, useCallback, createContext, useContext, useMemo, useRef } from 'react';

// @ts-expect-error File is untyped
import { UIOpt } from 'ui-addon-opt/components/UIOpt';
import useUserInfo from '../../hooks/useUserInfo';
import { gate as hubHttpGate } from 'hub-http/gates';
import I18n from 'I18n';
import { getIsOptedInForMarketingStudio, isViewOptedOut, getCachedOptinView, MARKETING_STUDIO_OPTIN_NAME } from './optinUtils';
import { StandaloneUsageTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StudioOptinContext = /*#__PURE__*/createContext({
  hasAccessToMarketingStudio: false,
  isLoadingOptinView: true
});
export const useStudioOptinContext = () => {
  const context = useContext(StudioOptinContext);
  const {
    isUngatedFor
  } = useUserInfo();
  if (context === undefined) {
    console.error('useStudioOptinContext must be used within a StudioOptinWrapper');
    const isUngatedForMarketingStudio = isUngatedFor(hubHttpGate('GoToMarketingStudio'));
    return {
      hasAccessToMarketingStudio: isUngatedForMarketingStudio,
      isLoadingOptinView: false
    };
  }
  return context;
};
const StudioOptinWrapper = ({
  children,
  onOptinStatusChange,
  defaultOptinView = null,
  shouldRenderOptin = true
}) => {
  const {
    isUngatedFor
  } = useUserInfo();
  const isUngatedForMarketingStudio = isUngatedFor(hubHttpGate('GoToMarketingStudio'));
  const [optinView, setOptinView] = useState(defaultOptinView);
  const [isLoadingOptinView, setIsLoadingOptinView] = useState(true);
  const hasLoadedOptinView = useRef(false);
  const hasAccessToMarketingStudio = useMemo(() => {
    return isUngatedForMarketingStudio && !isViewOptedOut(optinView);
  }, [isUngatedForMarketingStudio, optinView]);
  const handleOptinView = useCallback(targetView => {
    setOptinView(targetView || 'NEW');
    onOptinStatusChange === null || onOptinStatusChange === void 0 || onOptinStatusChange({
      isOptedOut: isViewOptedOut(targetView || 'NEW')
    });
    void getIsOptedInForMarketingStudio(targetView || 'NEW');
  }, [onOptinStatusChange]);
  useEffect(() => {
    if (hasLoadedOptinView.current || !isUngatedForMarketingStudio) return;
    getCachedOptinView().then(targetView => {
      handleOptinView(targetView);
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      hasLoadedOptinView.current = true;
      setIsLoadingOptinView(false);
    });
  }, [optinView, handleOptinView, isUngatedForMarketingStudio]);
  return /*#__PURE__*/_jsxs(StudioOptinContext.Provider, {
    value: {
      hasAccessToMarketingStudio,
      isLoadingOptinView: isUngatedForMarketingStudio ? isLoadingOptinView : false
    },
    children: [children, isUngatedForMarketingStudio && shouldRenderOptin && !isLoadingOptinView && /*#__PURE__*/_jsx(UIOpt, {
      optInButtonText: I18n.text('studio.optin.optInButtonText'),
      optOutButtonText: I18n.text('studio.optin.optOutButtonText'),
      optinName: MARKETING_STUDIO_OPTIN_NAME,
      optinView: optinView,
      onTargetOptinViewChanged: targetView => {
        handleOptinView(targetView);
      },
      tracker: StandaloneUsageTracker
    })]
  });
};
export default StudioOptinWrapper;